export function isUrl(path) {
  // eslint-disable-next-line
  const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g;
  return reg.test(path);
}

export const getLocaleUrl = (locale: string) => {
  const root: string = process.env.REACT_APP_SUB_FOLDER
    ? process.env.REACT_APP_SUB_FOLDER
    : "";

  let pathname = document.location.pathname.toLowerCase();
  let search = document.location.search;

  let pathnameArray = pathname
    .replace(root, "")
    .split("/")
    .filter((str) => !!str);

  pathnameArray[0] = locale;

  pathname = root + "/" + pathnameArray.join("/") + search;
  return pathname;
};

export const getOptionValue = (options, val) =>
  options.find((o) => o.value === val);

export const generateOptions = (options, f) => {
  return options.map((opt) => {
    opt.label = f({ id: opt.label });
    return opt;
  });
};

export const generateOptionLabel = (option, f) => {
  return f({ id: option.label });
};

export const LocaleMapping = {
  tc: "zh-TW",
  cn: "zh-CN",
  en: "en-US",
  jp: "ja-JP",
};

export const getUrlCodeByLanguage = () => {
  const languageCode = navigator.language;

  const LanguageEntry = Object.entries(LocaleMapping).find(
    (item) => item[1] === languageCode
  );
  if (LanguageEntry) {
    return LanguageEntry[0];
  } else {
    return "en";
  }
};

export const getParams = (param_name) => {
  let url_string = window.location.href;
  let url = new URL(url_string);
  let url_param = url.searchParams.get(param_name);
  return url_param;
};

export const getCurrencyLabel = (option, locale) => {
  switch (locale) {
    case "tc":
      return option.currencyFullNameChiTC;
    case "cn":
      return option.currencyFullNameChiSC;
    case "jp":
      return option.currencyFullNameChiJP;
    default:
      return option.currencyFullNameEng;
  }
};

export const encodeJSON = (item) => {
  return JSON.stringify(item);
};

export const decodeJSON = (str) => {
  try {
    return JSON.parse(str);
  } catch (err) {
    console.error("JSON DECODE ERROR", err);
    return {};
  }
};

export const setCookie = (key, val, expMin) => {
  val = encodeJSON(val);

  if (expMin) {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 60000 * expMin;
    now.setTime(expireTime);

    const exp = now.toUTCString();

    document.cookie = key + "=" + val + ";expires=" + exp + ";path=/";
  } else {
    document.cookie = key + "=" + val + ";path=/";
  }
};

export const getCookie = (key) => {
  let name = key + "=";

  let ca = document.cookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      const cookieValue = c.substring(name.length, c.length);
      return decodeJSON(cookieValue);
    }
  }

  return false;
};
